export enum ExaminationStatusResponse {
  started = 'started',
  pretestCompleted = 'pretest_completed',
  pretestDuring = 'pretest_during',
  processingResults = 'processing_results',
  maintestCompleted = 'maintest_completed',
  maintestDuring = 'maintest_during',
  finished = 'finished',
  failed = 'failed',
}
export interface ExaminationStatus {
  status: ExaminationStatusResponse;
}
export interface MainTestQuestion {
  id: number;
  question: string;
  sensitive: boolean;
}

export interface MainTestSingular {
  question: number;
  answer: string;
}

export interface EmailData {
  id: string;
  email: string;
}
export interface Email {
  email: string;
}

export interface EmailSendingStates {
  RemainingResends: number;
  detail: string;
}

export interface ExaminationResult {
  depression: Content;
  anxiety: Content;
  unstable_moods: Content;
  self_esteem: Content;
  submission: Content;
  summary: Content;
}

export interface Content {
  content: Text[];
  level?: string;
}
export interface Text {
  text: string;
  url: string;
}
